<template>
    <v-data-table
            :headers="headers"
            :items="users"
            sort-by="calories"
            class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Users</v-toolbar-title>
                <v-divider
                        class="mx-4"
                        inset
                        vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark
                               class="mb-2"
                               v-bind="attrs"
                               v-on="on">New User
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.username" label="Username"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.password" type="password" label="Password"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-select :items="roles" v-model="editedItem.role" return-object item-text="roleName" label="Role"></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                    small
                    @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
</template>

<script>
    import {CommonService, ParseUserService} from '../../services';
    import {mapGetters} from 'vuex';
    export default {
        name: "AdminUserPanel",
        data: () => ({
            dialog: false,
            headers: [
                {
                    text: 'Username',
                    align: 'start',
                    sortable: true,
                    value: 'username',
                },
                {text: 'Email', value: 'email', sortable: true},
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            users: [],
            roles: [],
            editedIndex: -1,
            editedItem: {
                user: null,
                role:null,
                username:'',
                email:'',
                password:'',
            },
            defaultItem: {
                user: null,
                role:null,
                username:'',
                email:'',
                password:''
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New User' : 'Edit User'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            ...mapGetters({
                getUsers: 'user/getUsers',
                getRoles: 'user/getRoles'
            }),
            initialize() {
                this.users = this.getUsers();
                this.roles = this.getRoles();
                if (!this.users.length) {
                    CommonService.showLoading(true);
                    ParseUserService.getAllUser().then(() => {
                        return ParseUserService.getAllRole()
                    }).catch(ex => {
                        console.log(ex);
                    }).finally(()=>{
                        CommonService.showLoading(false)
                    })
                }
            },
            editItem(item) {
                this.editedIndex = this.users.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true
            },

            deleteItem(item) {
                const index = this.roles.indexOf(item);
                confirm('Are you sure you want to delete this item?') && this.roles.splice(index, 1)
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save() {
                if (this.editedIndex > -1) {
                    this.showLoading();
                    ParseUserService.editUser(this.editedItem).then(() => {
                    //    Object.assign(this.roles[this.editedIndex], this.editedItem);
                    }).catch(ex => {
                        console.log(ex);
                    }).finally(() => {
                            this.stopLoading();
                            this.close();
                        }
                    );
                } else {
                    this.showLoading();
                    ParseUserService.addUser(this.editedItem).then((user) => {
                        this.editedItem.user = user;
                        this.$store.state.user.users.push(this.editedItem)
                    }).catch(ex => {
                        console.log(ex);
                    }).finally(() => {
                        this.stopLoading();
                        this.close();
                    });
                }
            },
            showLoading() {
                CommonService.showLoading(true);
            },
            stopLoading() {
                CommonService.showLoading(false);
            }
        }
    }
</script>

<style scoped>

</style>